import React, { useState } from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const PageTitle = styled.h2`
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 1rem;
`;

const PageDescription = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  
  h3 {
    margin-top: 0;
    color: #333;
    margin-bottom: 1rem;
  }
`;

const PDFViewerContainer = styled.div`
  width: 100%;
  height: 70vh;
  min-height: 500px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 1rem;
  
  @media (max-width: 768px) {
    height: 80vh;
    min-height: 400px;
  }
`;

const DownloadButton = styled.a`
  display: inline-block;
  background-color: #2D882D;
  color: white;
  text-decoration: none;
  border: none;
  border-radius: 4px;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 1rem;
  
  &:hover {
    background-color: #236D23;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

const HandbookPage = () => {
  // For now, we'll use a placeholder PDF URL
  // In a real app, this would come from your Supabase or other storage
  const [pdfUrl, setPdfUrl] = useState('https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf');

  return (
    <PageContainer>
      <PageTitle>Employee Handbook</PageTitle>
      <PageDescription>
        Access the latest version of the We Go Golf employee handbook here.
      </PageDescription>
      
      <Card>
        <h3>Current Handbook</h3>
        <p>
          The employee handbook contains important information about policies, 
          procedures, and guidelines. Please review it carefully and reach out 
          to management if you have any questions.
        </p>
        
        <PDFViewerContainer>
          <iframe
            src={`${pdfUrl}#toolbar=0&navpanes=0`}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="We Go Golf Employee Handbook"
          ></iframe>
        </PDFViewerContainer>
        
        <DownloadButton 
          href={pdfUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          download="WeGoGolf_Employee_Handbook.pdf"
        >
          Download PDF
        </DownloadButton>
      </Card>
      
      <Card>
        <h3>Additional Resources</h3>
        <ul>
          <li>Safety guidelines and protocols</li>
          <li>Equipment handling instructions</li>
          <li>Customer service best practices</li>
          <li>Event setup checklists</li>
          <li>Contact information for management team</li>
        </ul>
        <p>
          For access to these resources, please contact your supervisor.
        </p>
      </Card>
    </PageContainer>
  );
};

export default HandbookPage;